import { AuthEntryPage } from '@/pages/auth/ui/AuthEntryPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/auth/entry')({
  component: AuthEntryPage,
})
